export default {
    navigation: {
        krok: {
            title: "Крок",
            description: "Тренінг по КРОК-ах"
        },
    },
    loginKrok: {
        title: "Вхід в ePlato Step",
        code: "Код тестування",
        button: "Розпочати тестування",
        link: "Вхід в ePlato"
    },
    login: {
        title: "Вхід в ePlato",
        login: "Логін",
        password: "Пароль",
        button: "Увійти",
        linkQuiz: "Крок-тестування"
    },
    studentQuiz: {
        remaining: "Залишилося",
        automaticSwitch: "Автоматично переключати запитання",
        questionNo: "Питання №",
        previousQuestion: "Попереднє запитання",
        nextQuestion: "Наступне запитання",
        answeredQuestion: "На дане питання вже була дана відповідь",
        finishQuiz: "Завершити тестування",
        quizIsFinished: "Тестування завершено",
        logoutFromSystem: "Вийти зі системи"
    },
    studentKrok: {
        electronicRegister: "Електронний журнал",
        spaTraining: "Тренінг по СПА",
        ktiTraining: "Тренінг по (КРОК) КТІ",
        spaSubjects: "Дисципліни СПА",
        topics: "Теми",
        selectSubject: "Виберіть дисципліну",
        selectTopic: "Виберіть тему",
        questionsCount: "Кількість тестів для тестування",
        startQuiz: "Розпочати тестування",
        problematicQuestions: "Проблемні питання",
        attempt: "Спроба",
        from: "з",
        attemptsOnPage: "Спроб на сторінці",
        all: "Всі",
        continue: "Продовжити",
        start: "Початок",
        finish: "Завершення",
        questionCount: "Всього запитань",
        questionCorrectCount: "Вірних відповідей",
        questionCorrectPercentage: "% вірних відповідей",
        actions: "Дії",
        noData: "Немає даних",
        errorCount: "К-сть помилок:",
        close: "Закрити",
        noProblematicQuestions: "Наразі немає проблемних запитань",
        withProblematicQuestions: "Включити проблемні питання",
    },
    nbSupervisor: {
        quizComputers: "Список комп'ютерів"
    }
}